import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MDIncomeCertificateBodyModel } from 'src/app/model/MDIncomeCertificateBodyModel';
import { RegistrationModerationDocumentModel } from 'src/app/model/RegistrationModerationDocumentModel';

@Component({
  selector: 'app-secure-md-income-certificate',
  templateUrl: './md-income-certificate.component.html',
  styleUrls: []
})
export class MDIncomeCertificateComponent implements OnInit {
  @Input() registrationModerationDocument: RegistrationModerationDocumentModel;
  verifyForm: FormGroup = new FormGroup({});
  isVerifyDisabled: boolean;
  verifyErrorMessage: string;
  @Output() onSubmit = new EventEmitter<MDIncomeCertificateBodyModel>();
  departments: string[] = [];

  constructor() { }

  ngOnInit(): void { 
    console.log(this.registrationModerationDocument);
    this.verifyForm = new FormGroup({
      isDocReadable: new FormControl(null, [Validators.required]),
      hasBarcode: new FormControl(null, [Validators.required]),
      afterPeriod: new FormControl(null, [Validators.required]),
      barcode: new FormControl(null, [Validators.required]),
      reEnterBarcode: new FormControl(null, [Validators.required]),
      annualIncome: new FormControl(null, [Validators.required]),
    });
  }

  onSubmitVerify() {
    console.log('verify submit clicked', this.verifyForm);
    this.verifyErrorMessage = null;
    if (this.verifyForm.valid) {
      this.onSubmit.emit(new MDIncomeCertificateBodyModel(
        this.verifyForm.value.isDocReadable,
        this.verifyForm.value.hasBarcode,
        this.verifyForm.value.afterPeriod,
        this.verifyForm.value.barcode,
        this.verifyForm.value.reEnterBarcode,
        this.verifyForm.value.annualIncome,
        ));
    }
    else {
      this.verifyErrorMessage = "Please enter all mandatory fields";
      this.isVerifyDisabled = false;
    }
  }
}
